var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "logo", on: { "click": _vm.handleToPt } }, [_c('svg-icon', { staticClass: "icon", attrs: { "icon-class": "logo_p", "size": 24 } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };